import React, { Component } from 'react';

export default class Head extends Component {
	state = {on:true}
	componentDidMount() {
		this.updateValue()
	}
	updateValue() {
		global.setAnswer("assistOnScreen", this.state.on)
	}
	render() {
		return <div style={{}}>
			<img src={require('./img/assist_2.png')} style={{
				position:"absolute",
				left: 0,
				top: 32,
				width:361,
				height:289
			}} />
			<span style={{
				position:"absolute",
				left: 24,
				right: 24,
				top: 82,
				textAlign: "left",
				fontSize: 22,
			}}>Let the Assistant use what's on your screen</span>
			<span style={{
				position:"absolute",
				left: 24,
				right: 24,				
				top: 152,
				textAlign: "left",
				fontSize: 16,
			}}>Your Assistant can offer more relevant suggestions and specific actions related to shat's on your screen. You can change this in Assistant settings.</span>
			<span style={{
				position:"absolute",
				left: 64,
				right: 64,				
				top: 252,
				textAlign: "left",
				fontSize: 16,
			}}>Let your Assistant use what's on your screen to show you related info, apps, and actions.</span>


			<img src={this.state.on ? require('./img/rOn.png'): require('./img/rOff.png')} 
					onClick={() => this.setState({on:!this.state.on}, () => this.updateValue())}
					style={{
						position:"absolute",
						top:290,
						right:20,
						cursor:"pointer",
						width:45,
						height:45,
						alignSelf:"center"	

					}}
			/>
			
		</div>
	}

}



// WEBPACK FOOTER //
// ./src/Comp/Assist_prem_2.js